import styled from 'styled-components';
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT, SELECTORS, UBISOFT_BLUE } from '../../constants';
import { rgba } from "polished";

export const StarterPackContainer = styled.div`
    ${SELECTORS} & {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 50px 0 100px;
      
        @media (max-width: ${MOBILE_BREAKPOINT}) {
          display: block;
          padding: 0 0 50px;
        }
    }
`;

export const StarterPackLeft = styled.div`
    ${SELECTORS} & {
        flex: 0 0 425px;
        font-size: 20px;
        padding-right: 100px;
      
        @media (max-width: ${MOBILE_BREAKPOINT}) {
          margin-bottom: 30px;
          margin-right: 0;
          font-size: 16px;
          line-height: 19px;
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            flex: 0 0 50%;
            padding-right: 60px;
        }
    }
`;

export const StarterPackTitle = styled.h2`
    ${SELECTORS} & {
      margin-bottom: 15px;
      
      @media (max-width: ${MOBILE_BREAKPOINT}) {
        font-size: 32px;
        line-height: 38px;
      }
    }
`;

export const StarterPackDescription = styled.p`
    ${SELECTORS} & {
      font-size: 18px;
      text-align: left;
    }
`;

export const StarterPackRight = styled.div`
    ${SELECTORS} & {
        flex: 1;
        border: 10px solid ${rgba('#3c4145', 0.7)};
        border-radius: 20px;

        @media (max-width: ${TABLET_BREAKPOINT}) {
            margin-right: 20px;
            border: 0;
        }
    }
`;

export const RightBlockContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const IconContainer = styled.div`
    ${SELECTORS} & {
        flex: 0 0 45%;
        padding: 40px 75px;
      
        @media (max-width: ${TABLET_BREAKPOINT}) {
          display: none;
        }
        img,
        svg {
            width: 100% !important;
        }
        svg {
            max-height: 150px;
        }
    }
`;

export const ItemsListContainer = styled.div`
    ${SELECTORS} & {
        align-self: stretch;
        flex: 1;
        background-color: ${rgba('#3c4145', 0.7)};
        position: relative;
        padding: 20px 30px 20px 40px;

        @media (max-width: ${MOBILE_BREAKPOINT}) {
            padding: 0 20px;
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            padding: 10px 25px;
            border-radius: 20px;
        }
    }
`;

export const ItemsList = styled.ul`
    ${SELECTORS} & {
        list-style: none;
        margin: 0;
    }
`;

export const Item = styled.li`
    ${SELECTORS} & {
        display: flex;
        align-items: center;
        position: relative;
        padding: 28px 0;
        transition: .2s all ease-in-out;
      
        @media (max-width: ${TABLET_BREAKPOINT}) {
            padding: 20px 0;
        }
        &:not(.active) {
          &:not(:first-child) {
            &::after {
              @media (max-width: ${TABLET_BREAKPOINT}) {
                opacity: 0.5;
              }
            }
          }
        }
        &:not(:first-child) {
            &::after {
                content: "";
                height: 2px;
                background-color: white;
                position: absolute;
                top: 0;
                left: 5px;
                right: 5px;
                transition: .2s all ease-in-out;

                @media (max-width: ${TABLET_BREAKPOINT}) {
                    height: 1px;
                }
            }
        }
        &.active {
            padding: 35px 0;
            
            @media (max-width: ${TABLET_BREAKPOINT}) {
                padding: 28px 0;
            }
            + li,
            & {
                &::after {
                    opacity: 0 !important;
                }
            }
        }
        p {
            text-align: left;
            color: white;
            font-weight: ${props => props.theme.fontWeight};
        }
        > p {
            font-family: ${props => props.theme.font};
            font-size: 18px;
            line-height: 22px;
            max-width: 300px;
        }
    }
`;

interface ISVGContainerProps {
    isActive?: boolean;
    highlighted?: boolean;
}

export const SVGContainer = styled.div`
    ${SELECTORS} & {
        margin-right: 20px;
        display: ${({ highlighted }: ISVGContainerProps) =>
            highlighted ? 'none' : 'block'};

        @media (max-width: ${TABLET_BREAKPOINT}) {
            display: block;
        }
        svg {
            display: block;
            margin: auto;
            width: 60px;
            height: auto;

            @media (max-width: ${TABLET_BREAKPOINT}) {
                width: 45px;
            }
            path,
            ellipse {
              fill: #428ee0 !important;
            }
        }
    }
`;

export const ItemText = styled.p`
    ${SELECTORS} & {
    }
`;

interface IHighlightedTextProps {
    isActive: boolean;
    theme: any;
}

export const HighlightedText = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    background: #3c4145;
    border-radius: 20px;
    border: 4px solid ${UBISOFT_BLUE};
    box-shadow: 10px 10px 4px rgba(0, 0, 0, 0.25);
    padding: 36px 50px;
    left: -90px;
    right: 0;
    top: 50%;
    transform: ${({ isActive }: IHighlightedTextProps) =>
        isActive ? "translate(0, -50%)" : "translate(-20px, -50%)"};
    text-align: left;
    opacity: ${({ isActive }: IHighlightedTextProps) =>
        isActive ? "1" : "0"};
    transition: .2s all ease-in-out;
    transition-delay: .1s;
    z-index: 1;

    p {
        font-family: ${({ theme }: IHighlightedTextProps) => theme.boldFont};
        font-size: 24px;
        line-height: 28px;

        @media (max-width: ${TABLET_BREAKPOINT}) {
            font-size: 18px;
            line-height: 22px;
        }
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        left: 0;
        right: -40px;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        left: 0;
        right: -55px;
        padding: 24px 14px;
    }
`;
